import { combineReducers } from "redux";
import { registrationAttributes, userDetailsAttributes } from "./models";
import {
    REGISTRATION_ATTRIBUTES_CHANGED,
    RECEIVE_SUCCESSFUL_REGISTER_USER,
    RECEIVE_FAILURE_REGISTER_USER,
    REGISTRATION_ATTRIBUTES_VALIDATION_FAILURE,
    USER_DETAILS_ATTRIBUTES_CHANGED,
    USER_DETAILS_ATTRIBUTES_VALIDATION_FAILURE,
    RECEIVE_AUTHORIZED,
    RECEIVE_UNAUTHORIZED
} from "./actions/authenticationActions";
import { isAttributeValid } from "./validations";

const registrationAttributesReducer = (state = registrationAttributes(), action) => {
    return attributes(REGISTRATION_ATTRIBUTES_CHANGED, state, action);
};

const userDetailsAttributesReducer = (state = userDetailsAttributes(), action) => {
    return attributes(USER_DETAILS_ATTRIBUTES_CHANGED, state, action);
};

function attributes(type, state, action) {
    switch (action.type) {
        case type:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}

function submissionStatus(state = { success: false, errors: [] }, action) {
    switch (action.type) {
        case RECEIVE_SUCCESSFUL_REGISTER_USER:
            return Object.assign({}, state, { success: true, errors: []});
        case RECEIVE_FAILURE_REGISTER_USER:
            return Object.assign({}, state, { success: false, errors: action.payload});
        default:
            return state;
    }
}

function authenticatedUser(state = null, action) {
    switch (action.type) {
        case RECEIVE_AUTHORIZED:
            return action.payload;
        case RECEIVE_UNAUTHORIZED:
            return null;
        default:
            return state;
    }
}

function attributesWithErrors(failureEvent, changedEvent) {
    return function(state = [], action) {
        switch (action.type) {
            case failureEvent:
                return action.payload;
            case changedEvent:
                let errors = [].concat(state);

                Object.keys(action.payload).forEach(attribute => {
                    if (isAttributeValid(action.payload[attribute])) {
                        errors = errors.filter(attributeWithError => attributeWithError !== attribute);
                    } else {
                        errors = errors.concat(attribute);
                    }
                });

                return errors;
            default:
                return state;
        }
    }
}
const registrationAttributesWithErrors = attributesWithErrors(REGISTRATION_ATTRIBUTES_VALIDATION_FAILURE, REGISTRATION_ATTRIBUTES_CHANGED);
const userDetailsAttributesWithErrors = attributesWithErrors(USER_DETAILS_ATTRIBUTES_VALIDATION_FAILURE, USER_DETAILS_ATTRIBUTES_CHANGED);

const registration = combineReducers({
    attributes: registrationAttributesReducer,
    attributesWithErrors: registrationAttributesWithErrors,
    submissionStatus
});

const userDetails = combineReducers({
    attributes: userDetailsAttributesReducer,
    attributesWithErrors: userDetailsAttributesWithErrors
});

export default combineReducers({
    authenticatedUser,
    registration,
    userDetails
});


/** WEBPACK FOOTER **
 ** ./src/main/javascript/authentication/authenticationReducers.js
 **/